import { apiSlice } from "../../app/api/apiSlice";
import { logOut, setCredentials } from "./authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    sendLogout: builder.mutation({
      query: () => ({
        url: "/logout",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          // console.log("sending Logout");
          const { data } = await queryFulfilled;
          // console.log(data);
          dispatch(logOut());
          setTimeout(() => {
            dispatch(apiSlice.util.resetApiState());
          }, 1000);
        } catch (err) {
          // console.log(err);
        }
      },
    }),
    refresh: builder.mutation({
      query: () => ({
        url: "/refresh",
        method: "GET",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // // console.log(data);
          const { accessToken } = data;
          // // console.log(accessToken);
          dispatch(setCredentials({ accessToken }));
        } catch (err) {
          // // console.log(err);
        }
      },
    }),
    newRefreshToken: builder.mutation({
      query: (body) => {
        // console.log(body);
        return {
          url: "/refreshTokenViaEmbedString",
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useSendLogoutMutation,
  useRefreshMutation,
  useNewRefreshTokenMutation,
} = authApiSlice;
